import React from "react";

const AboutMe = () => {
  return (
    <div className="wrapper">
      <div className="title">
        <h6 className="text-primary text-uppercase">About Me</h6>
      </div>

      <div className="row gutter-width-md with-pb-md">
        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div className="description-2">
            <h2>
              Experienced mobile app developer focused on user-centric design.
            </h2>
          </div>

          <div className="signature spacer m-top-lg">
            <div className="signature-img">
              <img src="assets/img/demo/23_img.png" alt="About Me" />
            </div>
            <div className="signature-content">
              <h5 className="signature-name">Joren Vos</h5>
              <p className="signature-position">Jayvee</p>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div className="description-2">
            <p>
              As a mobile app developer with a passion for creating seamless
              digital experiences, I'm committed to helping businesses and
              individuals bring their ideas to life. With 8 years of experience
              in the industry, I've worked on projects from a variety of
              sectors, from startups to established businesses.
            </p>
          </div>

          <div className="description-2 spacer p-top-lg">
            <p>
              My approach to mobile app development is user-centric, and I
              believe that the best apps are those that provide a seamless and
              intuitive experience.
            </p>
          </div>

          <div className="description-2 spacer p-top-lg">
            <p>
              I'm excited to work with you to transform your ideas into mobile
              apps that exceed your expectations.
            </p>
          </div>
        </div>
      </div>

      <div className="icon-list">
        <div className="icon-list-items">
          <div className="icon-list-item">
            <p>
              <span className="d-flex">
                <i className="fas fa-check"></i>
                <span>User-centric design & accessibility</span>
              </span>
            </p>
          </div>

          <div className="icon-list-item">
            <p>
              <span className="d-flex">
                <i className="fas fa-check"></i>
                <span>Customized solutions</span>
              </span>
            </p>
          </div>

          <div className="icon-list-item">
            <p>
              <span className="d-flex">
                <i className="fas fa-check"></i>
                <span>Extensive industry knowledge</span>
              </span>
            </p>
          </div>

          <div className="icon-list-item">
            <p>
              <span className="d-flex">
                <i className="fas fa-check"></i>
                <span>Ongoing support</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
